import React from 'react'
import { FormattedMessage } from 'react-intl'
import KanBoIcon from 'components/KanBoIcon'
import { useCardContext } from 'dataProviders/Card'
import { useBoardContext, useBoardPermission } from 'dataProviders/Board'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import UnblockCard from './UnblockCard'
import EditCardBlocker from './EditCardBlocker'
import CardBlocker from 'components/CardBlocker'
import { ModalBoardContext, ModalCardContext } from 'components/Modal'
import Issue from '../Issue'
import styled from 'styled-components'
import { ListItem } from 'components/List'

const StyledListItem = styled(ListItem)`
  padding: 0;
`

type Props = LeftSidebarProps & {
  id: number;
  name: string;
  description?: any;
  creationDate: number;
  createdBy: string;
  reason?: string;
  userId?: number;
  isBusy?: boolean;
}

const BlockerIssue: React.FC<Props> = ({
  leftSidebar,

  id,
  name,
  description,
  creationDate,
  createdBy,
  reason,
  userId,
  isBusy,
}) => {
  const cardContext = useCardContext()

  const boardContext = useBoardContext()

  const permission = useBoardPermission()

  return (
    <Issue
      level='danger'
      icon={<KanBoIcon name='kanbo-16-block' />}
      title={<FormattedMessage id='BLOCKERS_CARD_BLOCKED' />}
      menu={(!isBusy && permission.member) ? [
        {
          icon: <KanBoIcon fixedWidth name='kanbo-16-unblock' />,
          title: <FormattedMessage id='BLOCKERS_CARD_UNBLOCK' />,
          onClick: () => {
            leftSidebar.push(() => <ModalCardContext cardId={cardContext.id}><UnblockCard cardBlockerId={id} /></ModalCardContext>)
          }
        }
      ] : undefined}
      onClick={(!isBusy && permission.member) ? () => {
        leftSidebar.push(() =>
          <ModalBoardContext boardId={boardContext.id}>
            <ModalCardContext cardId={cardContext.id}>
              <EditCardBlocker cardBlockerId={id} />
            </ModalCardContext>
          </ModalBoardContext>
        )
      } : undefined}
    >
      <CardBlocker
        component={StyledListItem}
        icon={null}
        name={name}
        description={description}
        creationDate={creationDate}
        createdBy={createdBy}
        reason={reason}
        userId={userId}
      />
    </Issue>
  )
}

export default withLeftSidebar(BlockerIssue)
